import React, { useCallback, useState } from 'react';
import CoinShopModal from '../pages/CoinShopModal';
import './AddCoinsPill.css';

const AddCoinsPill = ({ className = '', label = 'Add Coins' }) => {
  const [open, setOpen] = useState(false);

  const openModal = useCallback((e) => {
    // This pill is often rendered inside another clickable container (like a button).
    // Prevent triggering the parent click handler.
    e?.stopPropagation?.();
    setOpen(true);
  }, []);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openModal(e);
      }
    },
    [openModal]
  );

  return (
    <>
      <span
        role="button"
        tabIndex={0}
        className={`add-coins-pill ${className}`.trim()}
        onClick={openModal}
        onKeyDown={onKeyDown}
      >
        {label}
      </span>
      <CoinShopModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default AddCoinsPill;

